export enum DietTypeEnum {
    'dietetic' = 'dietetic',
    'texture' = 'texture',
    'fast' = 'fast',
    'invalid' = 'invalid',
}
